import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './i18n'
// Design-system tokens (CSS variables) must load before the app's own styles.
import '@parsleyai/ui/styles/tokens.css'
import './index.css'

const container = document.getElementById('root')

if (!container) {
  throw new Error('Root container not found. Make sure there is a <div id="root"> in your index.html.')
}

const root = createRoot(container)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
